import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { DAppCard } from './DAppCard';
import { top10Dapps } from '../data/dapps';

export const Top10Section = () => {
  const { t } = useLanguage();

  return (
    <section id="top10" className="relative py-20 md:py-32 section-gradient">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-testid="top10-headline">
            {t('top10.headline')}
          </h2>
          <p className="text-lg text-slate-300 max-w-3xl mx-auto">
            {t('top10.subtext')}
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {top10Dapps.map((dapp, index) => (
            <DAppCard 
              key={dapp.id} 
              dapp={dapp} 
              featured={index === 0}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
